import { useMoneyFormatter } from '../../hooks/use-money-formatter';
import type { FormatMoneyOptions } from '../../utils/format-money';

type FormattedMoneyProps = Omit<FormatMoneyOptions, 'locale'> & {
  locale?: string;
};

export function FormattedMoney({
  locale,
  amount,
  currency,
  token,
  overrides,
}: FormattedMoneyProps): string {
  const { formatMoney } = useMoneyFormatter(locale);
  const formatted = formatMoney({ amount, currency, token, overrides });

  return formatted;
}
